import moment, { Moment } from "moment";

const getDateRange = (days: number) => {
  return [moment().add(-days, "days"), moment().add(-1, "days")] as [
    Moment,
    Moment
  ];
};

export const RANGE_PICKER_QUICK_RANGES = {
  昨日: getDateRange(1),
  "近 7 天": getDateRange(7),
  "近 30 天": getDateRange(30),
  "近 90 天": getDateRange(90),
  "近 180 天": getDateRange(180),
  本周: [
    moment().startOf("week").add(1, "day"),
    moment().endOf("week").add(1, "day"),
  ] as [Moment, Moment],
  上周: [
    moment().startOf("week").add(-6, "day"),
    moment().endOf("week").add(-6, "day"),
  ] as [Moment, Moment],
  本月: [moment().startOf("month"), moment().endOf("month")] as [
    Moment,
    Moment
  ],
  上月: [
    moment().startOf("month").add(-1, "month"),
    moment().endOf("month").add(-1, "month"),
  ] as [Moment, Moment],
  今年: [moment().startOf("year"), moment().endOf("year")] as [Moment, Moment],
};

/**
 * 人群画像, 用来无数据的时候占位
 * @notice 这是复制的htj的数据, labelId无意义; 数据结构后端可能会有修改, 这里同步修改
 * @example /pro/crowd?tab=2&brand_id=15581&cate2_id=0&menu=crowd_perspective
 */
export const CROWD_PORTRAIT_DEFAULT_VALUE = [
  {
    title: "性别",
    labelId: 998550,
  },
  {
    title: "年龄",
    labelId: 998551,
  },
  {
    title: "购买力等级",
    labelId: 998552,
  },
  {
    title: "人设标签",
    labelId: 998553,
  },
  {
    title: "城市等级",
    labelId: 998554,
  },
  {
    title: "省份",
    labelId: 2223394,
  },
];

/** 数据展示的形式 */
export enum DisplayTypeEnums {
  /** 图 */
  CHART = "chart",
  /** 表格 */
  TABLE = "table",
}

/** FCPA枚举 */
export enum FcpaEnums {
  /** 认知 */
  FAMILIAR = "familiar",
  /** 兴趣 */
  CONSIDER = "consider",
  /** 购买 */
  PURCHASE = "purchase",
  /** 忠诚 */
  ADVOCATE = "advocate",
  /** 流失 */
  LOST = "lost",
}

export enum FcpaTypeEnums {
  /** 认知 */
  FAMILIAR = 1,
  /** 兴趣 */
  CONSIDER = 2,
  /** 购买 */
  PURCHASE = 3,
  /** 忠诚 */
  ADVOCATE = 4,
  /** 流失 */
  LOST = -1,
}

export enum FcpaEnumsUpper1 {
  /** 认知 */
  FAMILIAR = "Familiar",
  /** 兴趣 */
  CONSIDER = "Consider",
  /** 购买 */
  PURCHASE = "Purchase",
  /** 忠诚 */
  ADVOCATE = "Advocate",
}

export const FCPA_TYPE_MAP = {
  [FcpaTypeEnums.FAMILIAR]: FcpaEnums.FAMILIAR,
  [FcpaTypeEnums.CONSIDER]: FcpaEnums.CONSIDER,
  [FcpaTypeEnums.PURCHASE]: FcpaEnums.PURCHASE,
  [FcpaTypeEnums.ADVOCATE]: FcpaEnums.ADVOCATE,
  [FcpaTypeEnums.LOST]: FcpaEnums.LOST,
};

export const FCPA_NAME_MAP = {
  [FcpaEnums.FAMILIAR]: "认知",
  [FcpaEnums.CONSIDER]: "兴趣",
  [FcpaEnums.PURCHASE]: "购买",
  [FcpaEnums.ADVOCATE]: "忠诚",
  [FcpaEnums.LOST]: "流失",
};

export const FCPA_FULL_NAME_MAP = {
  [FcpaEnums.FAMILIAR]: "认知 Familiar",
  [FcpaEnums.CONSIDER]: "兴趣 Consider",
  [FcpaEnums.PURCHASE]: "购买 Purchase",
  [FcpaEnums.ADVOCATE]: "忠诚 Advocate",
  [FcpaEnums.LOST]: "流失 Lost",
};

export const FCPA_LIST = [
  FcpaEnums.FAMILIAR,
  FcpaEnums.CONSIDER,
  FcpaEnums.PURCHASE,
  FcpaEnums.ADVOCATE,
];

export const FCPA_TYPE_LIST = [
  FcpaTypeEnums.FAMILIAR,
  FcpaTypeEnums.CONSIDER,
  FcpaTypeEnums.PURCHASE,
  FcpaTypeEnums.ADVOCATE,
];

export const FCPA_BG_IMAGE = {
  [FcpaEnums.FAMILIAR]:
    "https://commimg.pddpic.com/upload/dmp/f_bg.png.slim.png",
  [FcpaEnums.CONSIDER]:
    "https://commimg.pddpic.com/upload/dmp/c_bg.png.slim.png",
  [FcpaEnums.PURCHASE]:
    "https://commimg.pddpic.com/upload/dmp/p_bg.png.slim.png",
  [FcpaEnums.ADVOCATE]:
    "https://commimg.pddpic.com/upload/dmp/a_bg.png.slim.png",
};

export const FCPA_BG_IMAGE_ACTIVE = {
  [FcpaEnums.FAMILIAR]:
    "https://commimg.pddpic.com/upload/dmp/f_bg_a.png.slim.png",
  [FcpaEnums.CONSIDER]:
    "https://commimg.pddpic.com/upload/dmp/c_bg_a.png.slim.png",
  [FcpaEnums.PURCHASE]:
    "https://commimg.pddpic.com/upload/dmp/p_bg_a.png.slim.png",
  [FcpaEnums.ADVOCATE]:
    "https://commimg.pddpic.com/upload/dmp/a_bg_a.png.slim.png",
};

/** 第1/2/3名的图片 */
export const RANK_IMAGES = {
  1: "https://commimg.pddpic.com/upload/dmp/266d38ff-f911-4e02-95af-97b2b4850c11.png.slim.png",
  2: "https://commimg.pddpic.com/upload/dmp/16dbf56a-2366-4914-8515-962f9441b4ad.png.slim.png",
  3: "https://commimg.pddpic.com/upload/dmp/69bd18d3-7c1a-479b-98f1-e7c83e66a6b3.png.slim.png",
};

export const FCPA_TOOLTIP_MAP = {
  [FcpaEnums.FAMILIAR]:
    "过去30天，有品牌商品曝光 且 没有主动搜索、点击等行为的人群",
  [FcpaEnums.CONSIDER]:
    "过去30天，有品牌店铺/商品搜索、点击、收藏、下单未支付等行为的人群",
  [FcpaEnums.PURCHASE]: "过去360天，仅有1天购买品牌商品且没有分享、好评的人群",
  [FcpaEnums.ADVOCATE]:
    "过去360天，品牌商品购买>1天或购买且分享或购买且5分好评的人群",
  [FcpaEnums.LOST]: "过去30天，没有品牌商品曝光、点击、搜索、购买、分享等行为",
};

/** dmp最外层的scroll dom */
export const getScrollWrapperDom = () => {
  return document.querySelector(".simplebar-content-wrapper");
};

export const CHART_SYMBOL =
  "image://data:image/svg+xml;charset=utf-8,<svg width=\"200\" height=\"200\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"100\" cy=\"100\" r=\"100\" fill=\"rgba(76,103,255,0.3)\"/><circle cx=\"100\" cy=\"100\" r=\"60\" fill=\"rgba(76,103,255,1)\"/></svg>";

export const CHART_COLOR_BLUE = [
  "#3649D9",
  "#4C67FF",
  "#BACBFF",
  "#E3EAFF",
  "#EDF2FF",
  "#F7F9FF",
];
